import { Fragment as notifee } from 'react';

export default notifee;